import React from "react";

const AntiDiscriminationPolicy = () => {
  return (
    <section className="section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-10 col-12 mx-auto policy-content">
            <h1>Anti-Discrimination Policy</h1>
            <p>
              <p>
                <strong>Anti-Discrimination and Equal Access Policy</strong>
              </p>
              <em>Omshakthi Monitoring Service – Curenza</em>
            </p>
            <p>
              Omshakthi Monitoring Service is committed to maintaining a
              platform that upholds the dignity and rights of all users,
              vendors, and staff, in accordance with the Constitution of India
              and applicable human rights laws..
            </p>
            <div className="content">
              <section>
                <h2>1. Our Commitment</h2>
                <p>We prohibit discrimination based on:</p>
                <ul>
                  <li>
                    Caste, religion, gender, age, sexual orientation, marital
                    status, disability, or language.
                  </li>
                </ul>
              </section>
              <section>
                <h2>2. Platform Conduct</h2>
                <p>
                  All users (customers, vendors, staff) are expected to behave
                  respectfully. Discriminatory comments or refusal of service
                  based on bias will lead to account suspension or permanent
                  ban.
                </p>
              </section>
              <section>
                <h2>3. Reporting and Redressal</h2>
                <p>
                  Discriminatory actions may be reported at{" "}
                  <a href="mailto:support@mycurenza.com">
                    support@mycurenza.com
                  </a>
                  . All reports will be investigated promptly, and appropriate
                  action will be taken.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AntiDiscriminationPolicy;
